import React, { useEffect, FC } from 'react';

import { ModelType } from '../../../../../interfaces/merchants/resources/books';
import { init } from '../../../../../redux/actions/merchants/resources/books';

import BaseLayoutMerchantOnlyFooter from '../../../../../components/layouts/BaseLayoutMerchantOnlyFooter';
import BookingErrorPage from '../../../../../organisms/merchants/resources/book/BookingErrorPage';

import css from './index.module.scss';
import { useShallowEqualSelector } from '../../../../../hooks/redux';
import { getMerchantResourcesBooks } from '../../../../../redux/selectors/merchants/resources/books';
import { ReduxState } from '../../../../../redux/reducers';
import { useUserMe } from '../../../../../hooks/api/me';
import ModelTypeSchool from '../../../../../organisms/merchants/resources/book/ModelTypeScool';
import ModelTypeCourse from '../../../../../organisms/merchants/resources/book/ModelTypeCourse';
import ModelTypeCourseWithStaff from '../../../../../organisms/merchants/resources/book/ModelTypeCourseWithStaff';
import ModelTypeEvent from '../../../../../organisms/merchants/resources/book/ModelTypeEvent';
import { LoadingIconWithReloadButton } from '../../../../../molecules/common/LoadingIconWithReloadButton';
import { useAppDispatch } from '../../../../../redux';

interface Props {
  merchantId: string;
  isAccepting?: boolean;
  resourceId: string;
  selectedDate?: string;
  selectedSlot?: string;
  selectedLesson?: string;
  selectedCourse?: string;
  selectedStaff?: string;
  lineLiffId: string | undefined;
  isCoubicApp: boolean;
}

const MerchantExpressBookPage: FC<Props> = ({
  merchantId,
  isAccepting,
  resourceId,
  selectedDate,
  selectedSlot,
  selectedLesson,
  selectedCourse,
  selectedStaff,
  lineLiffId,
  isCoubicApp,
}) => {
  const dispatch = useAppDispatch();
  const { meResponseData: loginUser } = useUserMe();
  const isEmailVerified = loginUser?.is_email_verified ?? false;

  useEffect(() => {
    dispatch(
      init({
        merchantId,
        resourceId,
        selectedDate,
        selectedSlot,
        selectedLesson,
        selectedCourse,
        selectedStaff,
        isEmailVerified,
      }),
    );
  }, [
    merchantId,
    resourceId,
    dispatch,
    selectedDate,
    selectedSlot,
    selectedLesson,
    selectedCourse,
    selectedStaff,
    isEmailVerified,
  ]);
  const merchantResourcesBooksState = useShallowEqualSelector(
    (state: ReduxState) => getMerchantResourcesBooks(state),
  );
  const { settings } = merchantResourcesBooksState;

  if (!settings) {
    return <LoadingIconWithReloadButton />;
  }
  const isAvailabilityType =
    isAccepting && settings.modelType === ModelType.AvailabilityScheme;
  const isEventType =
    isAccepting && settings.modelType === ModelType.EventScheme;
  const isAssignType =
    isAccepting && settings.modelType === ModelType.AssignScheme;
  const isSchoolType =
    isAccepting && settings.modelType === ModelType.SchoolScheme;

  return (
    <BaseLayoutMerchantOnlyFooter
      className={css.Index}
      isCoubicApp={isCoubicApp}
    >
      <div className={css.Index__BooksArea}>
        <div className={css.Index__BooksContent}>
          {!isAccepting && <BookingErrorPage withExpressFlow={true} />}
          {isAvailabilityType && (
            <ModelTypeCourse
              merchantId={merchantId}
              isExpressFlow={true}
              resourcePublicId={resourceId}
              lineLiffId={lineLiffId}
            />
          )}
          {isEventType && (
            <ModelTypeEvent
              merchantId={merchantId}
              isExpressFlow={true}
              resourcePublicId={resourceId}
              lineLiffId={lineLiffId}
            />
          )}
          {isAssignType && (
            <ModelTypeCourseWithStaff
              merchantId={merchantId}
              isExpressFlow={true}
              resourcePublicId={resourceId}
              lineLiffId={lineLiffId}
            />
          )}
          {isSchoolType && (
            <ModelTypeSchool
              merchantId={merchantId}
              isExpressFlow={true}
              resourcePublicId={resourceId}
              lineLiffId={lineLiffId}
            />
          )}
        </div>
      </div>
    </BaseLayoutMerchantOnlyFooter>
  );
};

export default MerchantExpressBookPage;
